module.exports = __webpack_public_path__ + "static/media/texture (27).50457df1.jpg";